import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["children", "renderSidebar", "actionsConfigOptions"];
import { DashboardPage } from 'foundations-components/transitional/components/DashboardPage';
import { ContentActionsProvider } from 'content-management-actions-lib/providers/ContentActionsProvider';
import ContentDetailsHeader from './headerDetails/ContentDetailsHeader';
import useActionSuccessUpdateHandlers from '../hooks/useActionSuccessUpdateHandlers';
import { CampaignsProvider } from 'campaigns-lib/campaignsPlatform';
import { jsx as _jsx } from "react/jsx-runtime";
const ContentDetailsPage = _ref => {
  let {
      children,
      renderSidebar = () => null,
      actionsConfigOptions
    } = _ref,
    headerDetailsProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  return /*#__PURE__*/_jsx(CampaignsProvider, {
    children: /*#__PURE__*/_jsx(ContentActionsProvider, Object.assign({}, actionsConfigOptions, {
      useActionSuccessUpdateHandlers: useActionSuccessUpdateHandlers,
      children: /*#__PURE__*/_jsx(DashboardPage, {
        headerComponent: /*#__PURE__*/_jsx(ContentDetailsHeader, Object.assign({}, headerDetailsProps, {
          actionsConfigOptions: actionsConfigOptions
        })),
        sidebarComponent: renderSidebar(),
        children: children
      })
    }))
  });
};
export default ContentDetailsPage;